import React, { useEffect, useState } from "react";
import { SYM } from "../utils/textSymbols";
import "./GamesPage.css";
import LicensePlateGamePage from "./LicensePlateGamePage";
import CoolBlockGamePage from "../games/coolBlock/CoolBlockGamePage";
import StateQuartersGamePage from "../games/stateQuarters/StateQuartersGamePage";
import HangmanGamePage from "../games/hangman/HangmanGamePage";
import MillionaireGamePage from "../games/millionaire/MillionaireGamePage";

export default function GamesPage({ apiBase, familyMembers, onInGameChange }) {
  const [view, setView] = useState("hub");

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [view]);

  useEffect(() => {
    onInGameChange?.(view !== "hub");
    return () => onInGameChange?.(false);
  }, [view, onInGameChange]);

  if (view === "cool-block") {
    return <CoolBlockGamePage onBack={() => setView("hub")} />;
  }

  if (view === "license-plate") {
    return (
      <LicensePlateGamePage
        apiBase={apiBase}
        familyMembers={familyMembers}
        onBack={() => setView("hub")}
      />
    );
  }

  if (view === "state-quarters") {
    return (
      <StateQuartersGamePage
        apiBase={apiBase}
        familyMembers={familyMembers}
        onBack={() => setView("hub")}
      />
    );
  }

  if (view === "hangman") {
    return (
      <HangmanGamePage
        apiBase={apiBase}
        familyMembers={familyMembers}
        onBack={() => setView("hub")}
      />
    );
  }

  if (view === "millionaire") {
    return (
      <MillionaireGamePage
        apiBase={apiBase}
        familyMembers={familyMembers}
        onBack={() => setView("hub")}
      />
    );
  }

  return (
    <div className="games-page">
      <h1 className="games-title">Games</h1>
      <p className="games-subtitle">Family road-trip fun</p>
      <button
        type="button"
        className="games-card"
        onClick={() => setView("millionaire")}
      >
        <span className="games-card-icon games-card-icon-img" aria-hidden="true">
          <img src={`${process.env.PUBLIC_URL || ""}/games/millionaire-logo.svg`} alt="" width="40" height="40" />
        </span>
        <span className="games-card-body">
          <span className="games-card-title">Who Wants to Be a Millionaire?</span>
          <span className="games-card-desc">15 questions. Lifelines. Climb the money tree!</span>
        </span>
        <span className="games-card-arrow" aria-hidden="true">{SYM.chevronRight}</span>
      </button>
      <button
        type="button"
        className="games-card"
        onClick={() => setView("hangman")}
      >
        <span className="games-card-icon games-card-icon-img" aria-hidden="true">
          <img src={`${process.env.PUBLIC_URL || ""}/games/hangman-logo.svg`} alt="" width="40" height="40" />
        </span>
        <span className="games-card-body">
          <span className="games-card-title">Hangman</span>
          <span className="games-card-desc">Chalkboard word guessing. Take turns. Score points!</span>
        </span>
        <span className="games-card-arrow" aria-hidden="true">{SYM.chevronRight}</span>
      </button>
      <button
        type="button"
        className="games-card"
        onClick={() => setView("license-plate")}
      >
        <span className="games-card-icon" aria-hidden="true">{SYM.car}</span>
        <span className="games-card-body">
          <span className="games-card-title">License Plate Game</span>
          <span className="games-card-desc">Spot all 50 states + territories. First spot wins!</span>
        </span>
        <span className="games-card-arrow" aria-hidden="true">{SYM.chevronRight}</span>
      </button>
      <button
        type="button"
        className="games-card"
        onClick={() => setView("state-quarters")}
      >
        <span className="games-card-icon" aria-hidden="true">¢</span>
        <span className="games-card-body">
          <span className="games-card-title">State Quarters</span>
          <span className="games-card-desc">Collect all 50 state quarters. First find wins!</span>
        </span>
        <span className="games-card-arrow" aria-hidden="true">{SYM.chevronRight}</span>
      </button>
      <button
        type="button"
        className="games-card"
        onClick={() => setView("cool-block")}
      >
        <span className="games-card-icon" aria-hidden="true">▦</span>
        <span className="games-card-body">
          <span className="games-card-title">Cool Block Game</span>
          <span className="games-card-desc">Stack blocks. Clear rows. Not Tetris, obviously.</span>
        </span>
        <span className="games-card-arrow" aria-hidden="true">{SYM.chevronRight}</span>
      </button>
    </div>
  );
}
